module.exports = __webpack_public_path__ + "img/citi.aa6e38a7.svg";